module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraLight.2bf45ea.eot";